import type { CustomerFlag } from '@/domain/types';

// Full literal Tailwind class strings (JIT can't see interpolated class names),
// mirroring FLAG_STYLE in bookingSummary.ts. mint = reassuring (waiver signed),
// blood = clinical alert, gold = allergy, azure = medication. `azure` is a
// theme-aware accent so the blue stays legible on the light parchment too.
export const CUSTOMER_FLAG_STYLE: Record<CustomerFlag, { label: string; cls: string }> = {
  'waiver-signed': { label: 'Waiver signed', cls: 'border-mint/50 bg-mint/15 text-mint' },
  'medical-condition': { label: 'Medical condition', cls: 'border-blood/50 bg-blood/15 text-blood' },
  allergy: { label: 'Allergy', cls: 'border-gold-bright/50 bg-gold/15 text-gold-bright' },
  'under-medication': { label: 'On medication', cls: 'border-azure/40 bg-azure/15 text-azure' },
  'photo-opt-out': { label: 'No photos', cls: 'border-cream-faint/50 bg-cream-faint/15 text-cream-soft' },
};
